import { InfoRow, NormalText } from "@components/styles/dataDisplay";
import React from "react";
import DOMPurify from "dompurify";

type LabeledRowProps = {
  label: string;
  value?: string | number;
  values?: string[] | number[];
  labelIcon?: React.ReactNode;
  isHtml?: boolean;
};

const getHtml = (value: string) => {
  const formatted = DOMPurify.sanitize(value);
  return { __html: formatted };
};

const LabeledRow: React.FC<LabeledRowProps> = ({ label, value, labelIcon, values, isHtml }) => {
  if (!value && !values) return null;
  if (typeof value === "string" && !value.trim()) return null;
  const isString = typeof value === "string";

  const WithLabelIcon = () => {
    if (!labelIcon)
      return (
        <NormalText semiBold color="gray">
          {label}
        </NormalText>
      );

    return (
      <div style={{ display: "flex", columnGap: 8, alignItems: "center" }}>
        <NormalText semiBold color="gray">
          {label}
        </NormalText>

        {labelIcon}
      </div>
    );
  };

  return (
    <InfoRow>
      <WithLabelIcon />
      {!isHtml && (
        <div style={{ display: "flex", flexDirection: "column", rowGap: 8 }}>
          {values?.length > 0 ? (
            values.map((value, index) => <NormalText key={index}>{value}</NormalText>)
          ) : (
            <NormalText>{value}</NormalText>
          )}
        </div>
      )}
      {isHtml && isString && (
        <NormalText dangerouslySetInnerHTML={getHtml(value)} style={{ whiteSpace: "pre-wrap" }} />
      )}
    </InfoRow>
  );
};

export default LabeledRow;
